import styled from "styled-components";


import BuiltInParameterConfiguration from "./BuiltInParameterConfiguration";
import ParameterType from "./ParameterType";
import SharedParameterConfiguration from "./SharedParameterConfiguration";
import { BIMClass, Parameter } from "../../../../../modules/shared-entities";
import Back from "../../../components/Back";

const Styled = styled.div`
    display: grid;
    gap: 0;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
`;

export default function Configuration(props) {
    const { next, prev, revitDefinition, setRevitDefinition } = props;

    return (
        <>
            <Back
                as="button"
                onClick={ props.prev }
            />
            <header>
                <Parameter id={ props.parameterID } />
                <BIMClass id={ props.bimClassID } />
            </header>
            <Styled>
                <ParameterType
                    active={ revitDefinition !== undefined && "id" in revitDefinition }
                    hint="choose from available Revit&nbsp;Built-in&nbsp;Parameters"
                    label="built-in"
                    onClick={ () => setRevitDefinition({ id: undefined }) }
                />
                <ParameterType
                    active={ revitDefinition !== undefined && !("id" in revitDefinition) }
                    disabled={ props.bimClassID }
                    hint={
                        props.bimClassID
                            ? "you cannot redefine Revit Shared Parameter for specific BIMClass"
                            : "set up Revit Shared Parameter from scratch or another parameter"
                    }
                    label="shared"
                    onClick={ () => setRevitDefinition({}) }
                />
            </Styled>
            {
                revitDefinition !== undefined && "id" in revitDefinition && (
                    <BuiltInParameterConfiguration
                        definition={ revitDefinition }
                        next={ next }
                        onChange={ setRevitDefinition }
                        prev={ prev }
                    />
                )
            }
            {
                revitDefinition !== undefined && !("id" in revitDefinition) && (
                    <SharedParameterConfiguration
                        definition={ revitDefinition }
                        next={ next }
                        onChange={ setRevitDefinition }
                        prev={ prev }
                    />
                )
            }
        </>
    );
}
